import { IError } from 'types/graphqlTypes'
import { useCreateCarrierApplicationMutation } from '../graphql/CreateCarrierApplicationMutation'
import { TCarrierApplicationSchema } from '../schema'

export interface ICarrierApplicationMutationResult {
  carrierApplicationId: string | undefined
  errors: IError[] | undefined
}

export interface IUseCarrierApplicationMutationsState {
  create: (formValues: TCarrierApplicationSchema) => Promise<ICarrierApplicationMutationResult>
  loading: boolean
}

const useCarrierApplicationMutations = (): IUseCarrierApplicationMutationsState => {
  const [createCarrier, { loading }] = useCreateCarrierApplicationMutation()

  const create = async (
    formValues: TCarrierApplicationSchema
  ): Promise<ICarrierApplicationMutationResult> => {
    const { data } = await createCarrier({
      variables: { input: { ...formValues } },
    })

    const { createCarrierApplication } = data || {}
    const { carrierApplication, errors } = createCarrierApplication || {}
    const { id } = carrierApplication || {}
    return {
      carrierApplicationId: id,
      errors,
    }
  }

  return {
    create,
    loading,
  }
}

export default useCarrierApplicationMutations
